var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5019 11.1818L3.35922 1.09683C3.20135 1.01777 3.02402 0.986089 2.84858 1.00561C2.67315 1.02513 2.50709 1.09501 2.3704 1.20684C2.23986 1.3164 2.14243 1.46024 2.08905 1.6222C2.03568 1.78416 2.02847 1.95782 2.06826 2.12365L4.77836 11.9977L2.03164 21.8443C1.9943 21.9828 1.98995 22.1281 2.01891 22.2686C2.04788 22.4091 2.10936 22.5408 2.19842 22.6531C2.28747 22.7655 2.40161 22.8554 2.53166 22.9155C2.66171 22.9757 2.80404 23.0044 2.94721 22.9995C3.09054 22.9986 3.23166 22.964 3.35922 22.8986L23.5019 12.8137C23.6519 12.7367 23.7777 12.6199 23.8656 12.4759C23.9535 12.3319 24 12.1665 24 11.9977C24 11.829 23.9535 11.6635 23.8656 11.5195C23.7777 11.3756 23.6519 11.2587 23.5019 11.1818ZM4.36635 20.3499L6.38978 12.9145H14.8497V11.0809H6.38978L4.36635 3.64556L21.039 11.9977L4.36635 20.3499Z",
    fill: "#007BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.810cb79b.svg";
export { ForwardRef as ReactComponent };